let archive = document.querySelector(".archive");

//Desktop
let sliderWrapDesk = document.querySelector(".slide-block-desktop");
let allSlidesDesk = sliderWrapDesk.querySelectorAll(".slide");
let slideLimitDesk = allSlidesDesk.length - 1;
let allNamesDesk = sliderWrapDesk.querySelectorAll(".controls .name");
let nameWrapDesk = document.querySelector(".ani-page .navigation-desktop .name");

window.addEventListener("load", function () {

  document.querySelector(".lookbook-pg main").classList.add("loaded");

  let season = document.querySelector(".ani-page").dataset.season;
  let seasonDesk = document.querySelector(".navigation-desktop .season");
  let seasonMob = document.querySelector(".navigation-mobile .season");

  let lookbookWrap = document.querySelector('.ani-page');
  let mensCheck = false;

  if(lookbookWrap.dataset.season == 'Mens'){
    mensCheck = true;
  }

  seasonDesk.innerHTML = season;
  seasonMob.innerHTML = season;

  let controlLinksDesk = document.querySelectorAll(".slide-block-desktop .slide .controls .name");

  controlLinksDesk.forEach(function (item, i) {
    let fullNamesDesk = item.querySelectorAll("a");

    fullNamesDesk.forEach(function (jtem, j) {
      //console.log(jtem.innerHTML);
      let currentName = jtem.innerHTML;
      //let theHandle = currentName.replace(/\s+/g, "-").toLowerCase();
      let preHandle = currentName.replace(/'/g, "");
      let theHandle = preHandle.replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, "-");
      //console.log(theHandle);

      if(mensCheck){
        if (theHandle == "nautilus-cigarette-box" || theHandle == "the-harvey-bracelet" || theHandle == "roberto-chain" || theHandle == "sterling-silver-coquille-box" || theHandle == "nautilus-knife" || theHandle == "harvey-bracelet" || theHandle == "quartz-coquille-box") {
        } else {
          theHandle = theHandle + "-mens";
          //console.log(theHandle);
        }
      }

      let ajaxPath = "/products/" + theHandle + ".js";
      //console.log(ajaxPath + " Desktop");
      // fetch(ajaxPath)
      //   .then(function (response) {
      //     return response.json();
      //   })
      //   .then(function (data) {
      //     jtem.setAttribute("href", data.url);
      //   })
      //   .catch(function (err) {
      //     //console.log(theHandle + " does not exist.");

      //     let mailLink = "mailto:?subject=" + currentName + "%20-%20Archive%20Product%20Inquiry&body=Let%20us%20know%20what%20you%20would%20like%20to%20know%20regarding%20this%20product.%20Thank%20you.";
      //     jtem.setAttribute("href", mailLink);
      //   });
    });
  });

  nameWrapDesk.innerHTML = allNamesDesk[0].innerHTML;

  allSlidesDesk.forEach(function (item, i) {
    if (i == 0) {
    } else {
      item.classList.add("hide");
    }

    let leftSide = item.querySelector(".left");
    let rightSide = item.querySelector(".right");

    leftSide.addEventListener("click", function () {
      //console.log("Left turn " + i);
      if (i == 0) {
        //let prev = 0;
      } else {
        let prev = i - 1;
        turnSlideDesk(prev);
        nameWrapDesk.innerHTML = allNamesDesk[prev].innerHTML;
      }
    });

    rightSide.addEventListener("click", function () {
      //console.log("Right turn " + i);
      if (i == slideLimitDesk) {
      } else {
        let next = i + 1;
        turnSlideDesk(next);
        nameWrapDesk.innerHTML = allNamesDesk[next].innerHTML;
      }
    });
  });

  let coverDefaultLinks = document.querySelectorAll(".navigation-desktop .name a");

  coverDefaultLinks.forEach(function (xtem, x) {
    let currentName = xtem.innerHTML;
    let preHandle = currentName.replace(/'/g, "");
    let theHandle = preHandle.replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, "-");

    if (lookbookWrap.dataset.season == "Mens") {
      mensCheck = true;
    }

    if (mensCheck) {
      if (theHandle == "nautilus-cigarette-box" || theHandle == "the-harvey-bracelet" || theHandle == "roberto-chain" || theHandle == "sterling-silver-coquille-box" || theHandle == "nautilus-knife" || theHandle == "harvey-bracelet" || theHandle == "quartz-coquille-box") {
      } else {
        theHandle = theHandle + "-mens";
        //console.log(theHandle + "Firsto");
      }
    }

    let ajaxPath = "/products/" + theHandle + ".js";
    // fetch(ajaxPath)
    //   .then(function (response) {
    //     return response.json();
    //   })
    //   .then(function (data) {
    //     xtem.setAttribute("href", data.url);
    //   })
    //   .catch(function (err) {
    //     //console.log(theHandle + " does not exist.");

    //     let mailLink = "mailto:?subject=" + currentName + "%20-%20Archive%20Product%20Inquiry&body=Let%20us%20know%20what%20you%20would%20like%20to%20know%20regarding%20this%20product.%20Thank%20you.";
    //     xtem.setAttribute("href", mailLink);
    //   });
  });
});

// $(document).ready(function () {
//   window.scrollTo(0, 0);
//   $("#toggle-index-desktop").on("click", function (e) {
//     e.preventDefault();
//     var slideHeight = window.innerHeight;
//     var fauxHeight = slideHeight - 99;
//     var slideWrapDesk = $(".slide-block-desktop");
//     var theBody = $("body");
//     var info = $(".archive");
//     var toggleCloseBtn = $("#toggle-index-desktop");

//     var speed = 300;

//     if (slideWrapDesk.hasClass("shrink")) {
//       slideWrapDesk.velocity(
//         {
//           height: fauxHeight,
//           width: "100%",
//         },
//         {
//           duration: 300,
//           //easing: "easeOutCubic",
//           easing: "ease",
//           complete: function () {
//             //window.scrollTo(0,0);
//             slideWrapDesk.removeClass("shrink");
//             theBody.removeClass("extend");
//             setTimeout(function () {
//               info.addClass("hide");
//             }, 300);
//           },
//         }
//       );
//       //info.addClass("hide");
//       toggleCloseBtn.text("Index");
//     } else {
//       slideWrapDesk.addClass("shrink").velocity(
//         {
//           height: 300,
//           width: 480,
//         },
//         {
//           duration: speed,
//           //easing: "easeOutCubic",
//           easing: "ease",
//           complete: function () {
//             theBody.addClass("extend");
//           },
//         }
//       );

//       //Slow Down here
//       info.removeClass("hide");
//       toggleCloseBtn.text("Close Index");
//     }
//   });
// });

/*



Mobile Lookbook



*/

let sliderWrapMob = document.querySelector(".slide-block-mobile");
let allSlidesMob = sliderWrapMob.querySelectorAll(".slide");
let slideLimitMob = allSlidesMob.length - 1;
let allNamesMob = sliderWrapMob.querySelectorAll(".controls .name");
let nameWrapMob = document.querySelector(".ani-page .navigation-mobile .name");

window.addEventListener("load", function () {
  let controlLinksMob = document.querySelectorAll(".slide-block-mobile .slide .controls .name");

  let lookbookWrapMob = document.querySelector(".ani-page");
  let mensCheckMob = false;

  if (lookbookWrapMob.dataset.season == "Mens") {
    mensCheckMob = true;
  }

  controlLinksMob.forEach(function (item, i) {
    let fullNamesMob = item.querySelectorAll("a");

    fullNamesMob.forEach(function (jtem, j) {
      //console.log(jtem.innerHTML);
      let currentName = jtem.innerHTML;
      let preHandle = currentName.replace(/'/g, "");
      let theHandle = preHandle.replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, "-");

      if (mensCheckMob) {
        if (theHandle == "nautilus-cigarette-box" || theHandle == "the-harvey-bracelet" || theHandle == "roberto-chain" || theHandle == "sterling-silver-coquille-box" || theHandle == "nautilus-knife" || theHandle == "harvey-bracelet" || theHandle == "quartz-coquille-box") {
        } else {
          theHandle = theHandle + "-mens";
          //console.log(theHandle);
        }
      }


      let ajaxPath = "/products/" + theHandle + ".js";
      //console.log(ajaxPath + " Mobile 1");
      // fetch(ajaxPath)
      //   .then(function (response) {
      //     return response.json();
      //   })
      //   .then(function (data) {
      //     jtem.setAttribute("href", data.url);
      //   })
      //   .catch(function (err) {
      //     //console.log(theHandle + " does not exist.");

      //     let mailLink = "mailto:?subject=" + currentName + "%20-%20Archive%20Product%20Inquiry&body=Let%20us%20know%20what%20you%20would%20like%20to%20know%20regarding%20this%20product.%20Thank%20you.";
      //     jtem.setAttribute("href", mailLink);
      //   });
    });
  });

  //nameWrapMob.innerHTML = allNamesMob[0].innerHTML;

  allSlidesMob.forEach(function (item, i) {
    if (i == 0) {
    } else {
      item.classList.add("hide");
    }

    let leftSide = item.querySelector(".left");
    let rightSide = item.querySelector(".right");

    leftSide.addEventListener("click", function (event) {
      event.preventDefault();
      //console.log("Left turn " + i);
      if (i == 0) {
        //let prev = 0;
      } else {
        let prev = i - 1;
        turnSlideMob(prev);
        nameWrapMob.innerHTML = allNamesMob[prev].innerHTML;
      }
    });

    rightSide.addEventListener("click", function (event) {
      event.preventDefault();
      //console.log("Right turn " + i);
      if (i == slideLimitDesk) {
      } else {
        let next = i + 1;
        turnSlideMob(next);
        nameWrapMob.innerHTML = allNamesMob[next].innerHTML;
      }
    });
  });

  let coverDefaultLinksMob = document.querySelectorAll(".navigation-mobile .name a");

  coverDefaultLinksMob.forEach(function (xtem, x) {
    let currentName = xtem.innerHTML;
    let preHandle = currentName.replace(/'/g, "");
    let theHandle = preHandle.replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, "-");

    if (lookbookWrapMob.dataset.season == "Mens") {
      mensCheckMob = true;
    }

    if (mensCheckMob) {
      if (theHandle == "nautilus-cigarette-box" || theHandle == "the-harvey-bracelet" || theHandle == "roberto-chain" || theHandle == "sterling-silver-coquille-box" || theHandle == "nautilus-knife" || theHandle == "harvey-bracelet" || theHandle == "quartz-coquille-box") {
      } else {
        theHandle = theHandle + "-mens";
      }
    }

    let ajaxPath = "/products/" + theHandle + ".js";
    //console.log(ajaxPath + " Mobile 2");
    // fetch(ajaxPath)
    //   .then(function (response) {
    //     return response.json();
    //   })
    //   .then(function (data) {
    //     xtem.setAttribute("href", data.url);
    //   })
    //   .catch(function (err) {
    //     //console.log(theHandle + " does not exist.");

    //     let mailLink = "mailto:?subject=" + currentName + "%20-%20Archive%20Product%20Inquiry&body=Let%20us%20know%20what%20you%20would%20like%20to%20know%20regarding%20this%20product.%20Thank%20you.";
    //     xtem.setAttribute("href", mailLink);
    //   });
  });

});

// $(document).ready(function () {
//   window.scrollTo(0, 0);
//   $("#toggle-index-mobile").on("click", function (e) {
//     e.preventDefault();
//     var slideHeight = window.innerHeight;
//     var fauxHeight = slideHeight - 100;
//     var slideWrapMob = $(".slide-block-mobile");
//     var theBody = $("body");
//     var info = $(".archive");
//     var toggleCloseBtn = $("#toggle-index-mobile");

//     var speed = 300;

//     if (slideWrapMob.hasClass("shrink-mobile")) {
//       slideWrapMob.velocity(
//         {
//           height: fauxHeight,
//           width: "100%",
//         },
//         {
//           duration: 300,
//           opacity: 0,
//           //easing: "easeOutCubic",
//           easing: "ease",
//           complete: function () {
//             //window.scrollTo(0,0);

//             theBody.removeClass("extend");
//             //slideWrapMob.style.opacity = 1;
//             setTimeout(function () {
//               info.addClass("hide");
//             }, 300);
//           },
//         }
//       );
//       slideWrapMob.removeClass("shrink-mobile");
//       //info.addClass("hide");
//       toggleCloseBtn.text("Index");
//     } else {
//       slideWrapMob.addClass("shrink-mobile").velocity(
//         {
//           height: 300,
//           width: "100%",
//         },
//         {
//           duration: speed,
//           //easing: "easeOutCubic",
//           easing: "ease",
//           complete: function () {
//             //theBody.addClass("extend");
//           },
//         }
//       );

//       //Slow Down here
//       info.removeClass("hide");
//       toggleCloseBtn.text("Close Index");
//     }
//   });
// });

//Functions
let turnSlideDesk = function (current) {
  allSlidesDesk.forEach(function (item, i) {
    if (current == i) {
      item.classList.remove("hide");
    } else {
      item.classList.add("hide");
    }
  });
};

let turnSlideMob = function (current) {
  let checkSS25 = document.querySelector("#shopify-section-lb-ss25-mobile");

  if(checkSS25 == null){ 
    allSlidesMob.forEach(function (item, i) {
      if (current == i) {
        item.classList.remove("hide");
      } else {
        item.classList.add("hide");
      }
    });
  }
};

/*
let collectionRows = document.querySelectorAll(".archive-loop");

collectionRows.forEach(function (item, i) {
  let parentCollection = item;
  let fullRows = item.querySelectorAll(".row");
  let rowArray = [];
  let rows = item.querySelectorAll(".row .product a");

  let lookbookWrapArc = document.querySelector('.ani-page');
  let mensCheckArc  = false;

  if(lookbookWrapArc .dataset.season == 'Mens'){
    mensCheckArc  = true;
  }

      if (lookbookWrapArc.dataset.season == "Mens") {
      mensCheckArc = true;
    }


  fullRows.forEach(function (ftem, f) {
    let fullName = ftem.querySelector(".product a").innerText.trim();
    let theHandle = fullName.replace(/\s+/g, "-").toLowerCase();

    if (mensCheckArc) {
      if (theHandle == "nautilus-cigarette-box" || theHandle == "the-harvey-bracelet" || theHandle == "roberto-chain" || theHandle == "sterling-silver-coquille-box" || theHandle == "nautilus-knife" || theHandle == "harvey-bracelet" || theHandle == "quartz-coquille-box") {
      } else {
        theHandle = theHandle + "-mens";
        //console.log(theHandle + "-Arc");
      }
    }

    let ajaxPath = "/products/" + theHandle + ".js";

    fetch(ajaxPath)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        //console.log('The title of this product is ' + data.title);

        //console.log(ftem);

        ftem.addEventListener("click", function () {
          window.location.href = data.url;
        });

        let eachLink = ftem.querySelectorAll("a");
        eachLink.forEach(function (item, i) {
          item.setAttribute("href", data.url);
        });
      })
      .catch(function (err) {
        //console.log(fullName + " does not exist.");
        let eachLink = ftem.querySelectorAll("a");
        let mailLink = "mailto:?subject=" + fullName + "%20-%20Archive%20Product%20Inquiry&body=Let%20us%20know%20what%20you%20would%20like%20to%20know%20regarding%20this%20product.%20Thank%20you.";

        eachLink.forEach(function (item, i) {
          item.setAttribute("href", mailLink);
        });

        ftem.addEventListener("click", function () {
          this.querySelectorAll("a")[0].click();
        });
      });
  });

  rows.forEach(function (jtem, j) {
    rowArray.push([jtem.innerText, j]);
  });

  rowArray.sort(function (x, y) {
    let a = x[0].toUpperCase(),
      b = y[0].toUpperCase();
    return a == b ? 0 : a > b ? 1 : -1;
  });

  //console.table(rowArray);

  let alphIndex = [];

  rowArray.forEach(function (ltem, l) {
    alphIndex.push(ltem[1]);
  });

  //console.log(prizmoLink);

  // item.addEventListener('click', function(){
  //   window.open(prizmoLink);
  // })

  //console.log(alphIndex);

  alphIndex.forEach(function (mtem, m) {
    //parentCollection.append(fullRows[mtem]);
  });
});
*/

$(document).ready(function () {
  resizeSite();
});

function resizeSite() {
  wh = $(window).height();


  var projects = $(".slide-block-mobile");
  if (projects.hasClass("collapsed")) {
  } else {
    projects.height(wh - 100);
  }
}
